export class ResponseApiModel<T> {
    data: T;

    constructor(init?: Partial<ResponseApiModel<T>>) {
        Object.assign(this, init);
    }
}